import { render, staticRenderFns } from "./WholesalerLogins.vue?vue&type=template&id=388956ef&scoped=true"
import script from "./WholesalerLogins.vue?vue&type=script&lang=js"
export * from "./WholesalerLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388956ef",
  null
  
)

export default component.exports